import { render, staticRenderFns } from "./OptionImage.vue?vue&type=template&id=8386ddc2"
import script from "./OptionImage.vue?vue&type=script&lang=js"
export * from "./OptionImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports